export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Flaskepant',
    },
    product_type: {
      label: 'Produkttype',
      options: {
        packaged: 'Pakket',
        prepared: 'Tilberedt',
      },
    },
    packaging_material: {
      label: 'Emballagemateriale',
    },
    brand_or_manufacturer: {
      label: 'Brand eller producent',
    },
    net_quantity: {
      label: 'Nettomængde',
    },
    base_price: {
      label: 'Angiv pris pr. enhed (f.eks. pr. liter for en drik)',
      placeholder: 'Pris pr. enhed',
    },
    alcohol_by_volume_percent: {
      label: 'Alkoholprocent',
    },
    caffeine_mg_per_100ml: {
      label: 'Koffein (mg pr. 100 ml produkt)',
    },
    ingredients_text: {
      label: 'Ingredienser',
    },
    allergens_list: {
      label: 'Allergener',
    },
    additives_list: {
      label: 'Tilsætningsstoffer',
    },
    has_nutrition_table: {
      label: 'Udfyld næringsdeklaration (pr. 100{{unit}} produkt)',
    },
    energy_kj: {
      label: 'Energi (kJ)',
    },
    energy_kcal: {
      label: 'Energi (kcal)',
    },
    fat_g: {
      label: 'Fedt',
    },
    saturates_g: {
      label: 'Mættede fedtsyrer',
    },
    carbohydrate_g: {
      label: 'Kulhydrat',
    },
    sugars_g: {
      label: 'Sukker',
    },
    protein_g: {
      label: 'Protein',
    },
    salt_g: {
      label: 'Salt',
    },
    identifiers: {
      label: 'Identifikatorer',
    },
  },
};
